import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=02cca5ad&scoped=true&"
import script from "./Feedback.vue?vue&type=script&lang=ts&"
export * from "./Feedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cca5ad",
  null
  
)

export default component.exports